export default {
    baseURL: process.env.VUE_APP_BASE_URL || '/api/ozs',
};
